import React from "react";
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {BreadcrumbItem, Breadcrumb} from 'react-bootstrap';
import { Link } from 'react-router-dom';


const FreeOpenAccessResources = () =>{
  
  return (
    <div className="FreeOpenAccessResources">
    
    <section className="inner-banner banner-align">
      <img className="img-fluid" src="./assets/img/innerbanner/open-access-banner-02.jpg" alt=""/>
    </section>
    <section  className="research-box-area">
         <Container>
         <Breadcrumb>
                <BreadcrumbItem>
                  <Link as={Link} to="/">
                         Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link as={Link} to="/FindResources">
                  Find Resources
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>Free/Open Access Resources</BreadcrumbItem>
              </Breadcrumb>
            <div className='information-content'>
              <h2>Free/Open Access Resources</h2>
              {/* <p>THe HU LICS has access to the following online research databases:</p> */}
            </div>
            <Row className="ParentBorderBox">
   <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>HathiTrust Digital Library</h5>
        {/* <p className="fw-bold">Computer Science & Mathematics</p> */}
        <p>HathiTrust Digital Library is an open-access digital repository that provides free online access to millions of digitized books and research materials from academic libraries worldwide. It allows users to read and download public-domain and openly licensed works, while also offering full-text search and accessibility features that make scholarly content widely discoverable and inclusive.</p>
        <a target="_blank" href="https://www.hathitrust.org/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://www.hathitrust.org/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>FreeTechBooks</h5>
        <p className="fw-bold">Computer Science & Mathematics</p>
        <p>Free Tech is a database of free open-access online computer science books, textbooks, and lecture notes. The collection is about 1238 free books (and growing).</p>
        <a target="_blank" href="https://www.freetechbooks.com/topics" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://www.freetechbooks.com/topics
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Directory of Open Access Books</h5>
        {/* <p className="fw-bold">Art, Music & Literary Preiodicals</p> */}
        <p>The Directory of Open Access Books (DOAB) is a database that refers readers to open-access books on publishers’ websites. These are peer-reviewed books that are published under an open-access license. DOAB has 34,309 academic peer-reviewed books from 412 publishers.</p>
        <a target="_blank" href="https://www.doabooks.org/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://www.doabooks.org/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>The Directory of Open Access Journals</h5>
        <p className="fw-bold">Directory of Open Access Journal</p>
        <p>DOAJ is a community-curated online directory that indexes and provides access to high quality, open access, peer-reviewed journals. All DOAJ services are free of charge including being indexed. DOAJ has 15,891 indexed journals and 5,603,579 indexed articles (and growing).</p>
        <ul>
            <li>
                <a target="_blank" href="https://doaj.org/" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    https://doaj.org/
                </a>
            </li>
            {/* <li>
                <a target="_blank" href="https:\doaj.org\search\journals%3fsource=%7b%22query%22:%7b%22match_all%22:%7b%7d%7d,%22size%22:50,%22sort%22:%5b%7b%22created_date%22:%7b%22order%22:%22desc%22%7d%7d%5d,%22track_total_hits%22:true%7d" className="link-btn wrongLink">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Journal Titles
                </a>
            </li> */}
            <li>
                <a target="_blank" href="https://doaj.org/search/articles?source=%7B%22query%22%3A%7B%22match_all%22%3A%7B%7D%7D%2C%22size%22%3A50%2C%22sort%22%3A%5B%7B%22created_date%22%3A%7B%22order%22%3A%22desc%22%7D%7D%5D%2C%22track_total_hits%22%3Atrue%7D" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Articles
                </a>
            </li>
        </ul>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>World Bank Open Knowledge Repository</h5>
        <p className="fw-bold">Economics & Finance</p>
        <p>The World Bank Open Knowledge Repository (OKR) has provided free access to all World Bank publications since 2000. Around 31,646 publications are available at World Bank OKR</p>
        <a target="_blank" href="https://openknowledge.worldbank.org/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://openknowledge.worldbank.org/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Government Finance Statistics Online (IMF)</h5>
        <p className="fw-bold">Economics & Finance</p>
        <p>The IMF Government Finance Statistics (GFS) is the standard reference source for governments of IMF member countries. IMF E-Library has 2,999 books, 19,120 Journals, and issues along with 67,579 chapters and articles.</p>
        <ul>
            <li>
                <a target="_blank" href="https://www.elibrary.imf.org/browse?pageSize=10&sort=datedescending" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    https://www.elibrary.imf.org/
                </a>
            </li>
            <li>
                <a target="_blank" href="https://www.elibrary.imf.org/browse?submittedFilterId=by-content-type&pageSize=10&sort=datedescending&type_4=journal&type_5=article-contents" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Journal Titles
                </a>
            </li>
            <li>
                <a target="_blank" href="https://www.elibrary.imf.org/browse?submittedFilterId=by-content-type&pageSize=10&sort=datedescending&type_3=book" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Books
                </a>
            </li>
        </ul>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>GreenFILE (via EbscoHost)</h5>
        <p className="fw-bold">Environmental Science</p>
        <p>GreenFILE is a free research database covering all aspects of human impact to the environment. Its collection of scholarly, government, and general-interest titles includes content on global warming, green building, pollution, sustainable agriculture, renewable energy, recycling, and more. Green FILE has Indexing and abstracts of more than 1.1 million records and open-access full text for more than 15,800 records.</p>
        <a target="_blank" href="https://www.ebsco.com/products/research-databases/greenfile" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://www.ebsco.com/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>OARE: Research in the Environment</h5>
        <p className="fw-bold">Enviromental Science</p>
        <p>OARE (Online Access to Research in the Environment) is a public-private partnership sponsored by the U.N Environment Programme and Yale University. It provides access to a wide range of scientific journals, books, and other content resources in the environmental sciences and at prices that reflect the state of national economies in the developing world. OARE gives access to 2,543 free journals and 8,118 free books.</p>
        <ul>
            <li>
                <a target="_blank" href="https://portal.research4life.org\" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    https:\portal.research4life.org\
                </a>
            </li>
            <li>
                <a target="_blank" href="https://portal.research4life.org/search/advancedsearch" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Journal Titles
                </a>
            </li>
            <li>
                <a target="_blank" href="https://portal.research4life.org/content/books" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Books
                </a>
            </li>
        </ul>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Open Humanities Press</h5>
        <p className="fw-bold">Humanities</p>
        <p>Open Humanities contains peer-reviewed journals and books on humanities, and it explores new forms of scholarly communication. OH has 60+ books and 20+ Journals.</p>
        <ul>
            <li>
                <a target="_blank" href="http://www.openhumanitiespress.org/" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    http://www.openhumanitiespress.org/
                </a>
            </li>
            <li>
                <a target="_blank" href="http://www.openhumanitiespress.org/journals/titles/" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Journal Titles
                </a>
            </li>
            <li>
                <a target="_blank" href="http://www.openhumanitiespress.org/books/series/" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Books
                </a>
            </li>
        </ul>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Brill Open Access</h5>
        <p className="fw-bold">Humanities and Social Sciences</p>
        <p>Brill’s publications focus on the humanities and social sciences, international law, and selected areas in the sciences. Brill has 33 online access journals, around 582 free books with approx 22,500 free articles.</p>
        <ul>
            <li>
                <a target="_blank" href="https://brill.com/page/oageneral/general-open-access-information" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    https://brill.com/page/oageneral/general-open-access-information
                </a>
            </li>
            <li>
                <a target="_blank" href="https://brill.com/browse?access=open&et=journal&level=parent&pageSize=10&sort=datedescending" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Journal Titles
                </a>
            </li>
            <li>
                <a target="_blank" href="https://brill.com/browse?access=open&et=book&level=parent&pageSize=10&sort=datedescending" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Books
                </a>
            </li>
        </ul>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>IT eBooks</h5>
        <p className="fw-bold">Information Technology</p>
        <p>IT eBooks is a collection of free information technology books for downloading. The IT has 30 free e-books.</p>
        <a target="_blank" href="https://it-ebooks.info/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://it-ebooks.info/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Google Scholar</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>Google Scholar provides a simple way to broadly search for scholarly literature. Search across a wide variety of disciplines and sources: articles, theses, books, abstracts, and court opinions.</p>
        <a target="_blank" href="https://scholar.google.com/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://scholar.google.com/
        </a>
    </div>
    </Col>

    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Internet archive</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>Internet Archive is a non-profit library of millions of free books, movies, software, music, websites, and more.</p>
        <a target="_blank" href="https://archive.org/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://archive.org/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Project Gutenberg</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>Project Gutenberg is an online library of free eBooks. Project Gutenberg was the first provider of free electronic books or eBooks. Currently, it has a collection of 60,000 e-books.</p>
        <a target="_blank" href="https://www.gutenberg.org/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://www.gutenberg.org/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Cambridge Open Access</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>Open Access at the University of Cambridge is managed by two dedicated support services: Open Access and Research Data Management. These groups assist the University's researchers and research students in making their research outputs freely accessible in the public domain. It has 315 open-access journals, 33,586 open-access articles, and 101 open-access books.</p>
        <ul>
            <li>
                <a target="_blank" href="https://www.cambridge.org/core/what-we-publish/open-access" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    https://www.cambridge.org/core/what-we-publish/open-access
                </a>
            </li>
            <li>
                <a target="_blank" href="https://www.cambridge.org/core/what-we-publish/open-access/hybrid-open-access-journals?aggs%5bproductTypes%5d%5bfilters%5d=JOURNAL&sort=titleSort:asc" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Journal Titles
                </a>
            </li>
            <li>
                <a target="_blank" href="https://www.cambridge.org/core/what-we-publish/open-access/listing?aggs%5bproductTypes%5d%5bfilters%5d=BOOK&sort=canonical.date:desc" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Books
                </a>
            </li>
        </ul>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Pure Gold Open Access Journal (SAGE)</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>The pure gold open-access journals published by SAGE. All articles published in the journals provide worldwide, barrier-free access to the full text of articles online, immediately upon publication under a Creative Commons license.</p>
        <a target="_blank" href="https://in.sagepub.com/en-in/sas/pure-gold-open-access-journals-at-sage" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://in.sagepub.com/en-in/sas/pure-gold-open-access-journals-at-sage
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>CORE</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>CORE is the world’s largest collection of open-access research papers. It aggregates and enriches open-access research papers from around the world. Core documents 200 million papers from around the world.</p>
        <a target="_blank" href="https://core.ac.uk/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://core.ac.uk/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>JSTOR Open</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>More than 6,500 open-access eBooks and journals are available from top scholarly publishers, including Brill, Cornell University Press, De Gruyter, and University of California Press.</p>
        <ul>
            <li>
                <a target="_blank" href="https://about.jstor.org/oa-and-free/" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    https://about.jstor.org/oa-and-free/
                </a>
            </li>
            <li>
                <a target="_blank" href="https://about.jstor.org/oa-and-free/open-access-journals/" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Journal Titles
                </a>
            </li>
            <li>
                <a target="_blank" href="https://about.jstor.org/librarians/books/open-access-books-jstor/" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Books
                </a>
            </li>
        </ul>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Open Access Theses and Dissertations</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>OATD provides resources for finding open-access graduate theses and dissertations published worldwide. Metadata (information about the theses) comes from over 1100 colleges, universities, and research institutions. OATD currently indexes over 5 million theses and dissertations (and growing).</p>
        <a target="_blank" href="https://oatd.org/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://oatd.org/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Open Access Project Muse</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>Project MUSE offers open access (OA) books and journals from many distinguished university presses and scholarly societies. There are over 2,000 open-access books and a small number of fully OA journals on the MUSE platform.</p>
        <ul>
            <li>
                <a target="_blank" href="https://muse.jhu.edu/search?action=oa_browse" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    https://muse.jhu.edu/search?action=oa_browse
                </a>
            </li>
            <li>
                <a target="_blank" href="https://muse.jhu.edu/search?action=oa_browse&limit=subscription:n&limit=format:journal&min=1&max=20" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Journal Titles
                </a>
            </li>
            <li>
                <a target="_blank" href="https://muse.jhu.edu/search?action=oa_browse&limit=subscription:n&limit=format:book&min=1&max=10&t=format_facet_select" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Books
                </a>
            </li>
        </ul>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Wiley Online</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>Wiley online covers journals, books, and research resources, covering life, health, social, and physical sciences. It has 2,500+ Journals and 24,000+ online books (and growing).</p>
        <ul>
            <li>
                <a target="_blank" href="https://onlinelibrary.wiley.com/" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    https://onlinelibrary.wiley.com/
                </a>
            </li>
            <li>
                <a target="_blank" href="https://onlinelibrary.wiley.com/action/showPublications?PubType=journal" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Journal Titles
                </a>
            </li>
            <li>
                <a target="_blank" href="https://onlinelibrary.wiley.com/action/showPublications?PubType=book" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Books
                </a>
            </li>
        </ul>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Scholar Commons</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>It is a collection of open-access textbooks provided by the University of South Florida.</p>
        <ul>
            <li>
                <a target="_blank" href="https://scholarcommons.usf.edu/communities.html" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    https://scholarcommons.usf.edu/communities.html
                </a>
            </li>
            <li>
                <a target="_blank" href="https://scholarcommons.usf.edu/journals.html#collection" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Journal Titles
                </a>
            </li>
        </ul>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Online Books</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>Online Books is an e-book website that contains a myriad of books in various disciplines. The site is hosted by the University of Pennsylvania Libraries. It facilitates access to 2 million books that are freely readable on the Internet.</p>
        <a target="_blank" href="http://onlinebooks.library.upenn.edu/lists.html" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            http://onlinebooks.library.upenn.edu/lists.html
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>BENTHAM Open</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>BENTHAM Open publishes several peer-reviewed open-access journals. These free-to-view online journals cover all major disciplines of science, technology, medicine, and social sciences.</p>
        <a target="_blank" href="https://benthamopen.com/browse-by-title/A/1/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://benthamopen.com/browse-by-title/A/1/
        </a>
    </div>
    </Col>
    {/* */}
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Taylor & Francis Open Journal</h5>
        <p className="fw-bold">Enviromental</p>
        <p>Taylor & Francis offers a variety of publishing options, open-access journal publications of peer-reviewed and scholarly sources are available.</p>
        <ul>
            <li>
                <a target="_blank" href="https://www.tandfonline.com/openaccess" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    https://www.tandfonline.com/openaccess
                </a>
            </li>
            <li>
                <a target="_blank" href="https://www.tandfonline.com/openaccess/openjournals" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Journal Titles
                </a>
            </li>
            <li>
                <a target="_blank" href="https://www.tandfonline.com/openaccess/books" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Books
                </a>
            </li>
        </ul>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>E-Books Directory</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>E-Books Directory has links to freely accessible eBooks and has up to 10,839 free e-books in 709 categories.</p>
        <a target="_blank" href="https://www.e-booksdirectory.com/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://www.e-booksdirectory.com/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Open Textbook Library</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>Open textbooks are licensed by authors and publishers to be freely used and adapted. About 840 books are available for free use.</p>
        <a target="_blank" href="https://open.umn.edu/opentextbooks" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://open.umn.edu/opentextbooks
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>OpenStax</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>OpenStax has created peer-reviewed, openly licensed textbooks, which are available in free digital formats on different subjects.</p>
        <a target="_blank" href="https://openstax.org/subjects" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://openstax.org/subjects
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>B.C. Open Textbook Collection</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>The B.C. Open Textbook Collection is a selection of open textbooks for a variety of subjects Open textbooks that have been reviewed and include ancillary materials (quizzes, test banks, slides, videos, etc.). Up to 400 open-access books are available.</p>
        <a target="_blank" href="https://open.bccampus.ca/browse-our-collection/find-open-textbooks/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://open.bccampus.ca/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>IEEE Access</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>IEEE Access is a multidisciplinary, open-access journal of the IEEE. Presenting the results of original research across all of IEEE’s fields of interest, IEEE Access provides authors with ahigh-quality open-access journal with a rapid yet rigorous peer review process of 4 to 6 weeks.</p>
        <a target="_blank" href="https://ieeeaccess.ieee.org/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://ieeeaccess.ieee.org/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>arXiv</h5>
        <p className="fw-bold">Multidisciplinary Science</p>
        <p>arXiv is a free distribution service and an open-access archive for 1.8 million scholarly articles (and growing) in the fields of physics, mathematics, computer science, quantitative biology, quantitative finance, statistics, electrical engineering, systems science, and economics.</p>
        <a target="_blank" href="https://arxiv.org/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://arxiv.org/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>The International Nuclear Information System (INIS)</h5>
        <p className="fw-bold">Nuclear Sci & Tec</p>
        <p>The INIS repository includes research on a wide range of nuclear-related topics, from environmental science and energy storage to radiology and many more. Approximately 120,000 bibliographic records and 13,000 full-text PDF documents are added each year.</p>
        <a target="_blank" href="https://inis.iaea.org/search/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://inis.iaea.org/search/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Stanford Encyclopedia of Philosophy</h5>
        <p className="fw-bold">Philosophy</p>
        <p>The Stanford Encyclopedia of Philosophy organizes scholars from around the world in philosophy and related disciplines to create and maintain an up-to-date reference work.</p>
        <a target="_blank" href="https://plato.stanford.edu/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://plato.stanford.edu/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>NOBA</h5>
        <p className="fw-bold">Psychology</p>
        <p>NOBA is a free online platform that provides high-quality, flexibly structured textbooks and educational materials in the field of psychology. Free Sign up is required to fully access the resources.</p>
        <a target="_blank" href="https://nobaproject.com/browse-content" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://nobaproject.com/browse-content
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Science Direct</h5>
        <p className="fw-bold">Science</p>
        <p>Science Direct offers over 1.4 million open articles. Articles published open-access are peer-reviewed and made freely available for everyone along with 93 open-access journals.</p>
        <ul>
            <li>
                <a target="_blank" href="https://www.sciencedirect.com/" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    https://www.sciencedirect.com/
                </a>
            </li>
            <li>
                <a target="_blank" href="https://www.sciencedirect.com/browse/journals-and-books?contentType=JL&accessType=openAccess" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Journal Titles
                </a>
            </li>
        </ul>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Springer Open</h5>
        <p className="fw-bold">Science</p>
        <p>Springer Open journals and books are made freely and permanently available online immediately upon publication. They are subject to high-level peer review, author, and production services ensuring the quality and reliability of work.</p>
        <ul>
            <li>
                <a target="_blank" href="https://www.springeropen.com/" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    https://www.springeropen.com/
                </a>
            </li>
            <li>
                <a target="_blank" href="https://www.springeropen.com/journals" className="link-btn">
                    <img src="./assets/img/link-icon.svg" alt="" />
                    Access to Journal Titles
                </a>
            </li>
        </ul>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Intech</h5>
        <p className="fw-bold">Science</p>
        <p>Intech is one of the largest multidisciplinary open-access publishers of books covering the fields of science, technology, medicine, engineering, health sciences, life sciences, social sciences, and humanities. Over 5,100 peer-reviewed open-access books are available at Intech.</p>
        <a target="_blank" href="https://www.intechopen.com/books" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://www.intechopen.com/
        </a>
    </div>
    </Col>
    
    {/* <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>The Woman Stats Project</h5>
        <p className="fw-bold">Women Empowerment</p>
        <p>The Woman Stats Project is the most comprehensive compilation of information on the status of women in the world. The Project facilitates an understanding of the linkage between the situation of women and the security of nation-states. Free Sign-up is required to fully access the resources.</p>
        <a target="_blank" href="http://www.womanstats.org/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            http://www.womanstats.org/
        </a>
    </div>
    </Col> */}
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Refseek</h5>
        {/* <p className="fw-bold">Multidisciplinary</p> */}
        <p>Academic Resource Search. More than a billion sources: encyclopedias, monographs, and magazines.</p>
        <a target="_blank" href="http://www.refseek.com" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            http://www.refseek.com
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Worldcat</h5>
        {/* <p className="fw-bold">Multidisciplinary</p> */}
        <p>A search for the contents of 20 thousand worldwide libraries to locate the nearest rare book you need.</p>
        <a target="_blank" href="http://www.worldcat.org" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            http://www.worldcat.org
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Research Papers in Economics</h5>
        {/* <p className="fw-bold">Multidisciplinary</p> */}
        <p>Volunteers from 102 countries have collected almost 4 million publications on economics and related science.</p>
        <a target="_blank" href="http://repec.org" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            http://repec.org
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>PDFDrive</h5>
        {/* <p className="fw-bold">Multidisciplinary</p> */}
        <p>PDFDrive is the largest website for free download of books in PDF format, claiming over 225 million names. </p>
        <a target="_blank" href="http://www.pdfdrive.com" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            http://www.pdfdrive.com
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Base-Search</h5>
        {/* <p className="fw-bold">Multidisciplinary</p> */}
        <p>Base-Search is one of the most powerful researches on academic studies texts. With more than 100 million scientific documents, 70% of them are free.</p>
        <a target="_blank" href="http://www.base-search.net" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            http://www.base-search.net
        </a>
    </div>
    </Col>
</Row>
<div className='SubHeadingWrap'>
    <h3>OTHER RESOURCES</h3>
</div>
<Row className="ParentBorderBox">
   
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Massachusetts Institute of Technology (MIT) Open Courseware</h5>
        <p className="fw-bold">Science & Technology</p>
        <p>MIT Open Course Ware (MIT OCW) is a multidisciplinary open educational resources repository, containing thousands of MIT courses, a curriculum ranging from the introductory to the most advanced graduate level. Each OCW course includes a syllabus, some instructional materials, and some learning activities. Many courses also have complete video lectures and free online textbooks.</p>
        <a target="_blank" href="https://ocw.mit.edu/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://ocw.mit.edu/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>Open Culture</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>An online platform that provides cultural and educational media and resources. It provides its users with movies, language resources, K-12 resources, online courses, certificate courses, e-books, audiobooks, textbooks on different subjects, and much more. It has a collection of 300 language lessons 1,150 free movies 700 audio books, up to 1000 books and much more to offer.</p>
        <a target="_blank" href="https://www.openculture.com/" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://www.openculture.com/
        </a>
    </div>
    </Col>
    <Col lg={4} sm={6} className="bord">
    <div className="research-box">
        <h5>MERLOT</h5>
        <p className="fw-bold">Multidisciplinary</p>
        <p>MERLOT (Multimedia Education Resource for Learning and Online Teaching) is a multidiscipline online repository and international consortium of institutions (and systems) of higher education, industry partners, professional organizations, and individuals who work together in various ways to provide users OER (Open Educational Resources).</p>
        <a target="_blank" href="https://www.merlot.org/merlot/materials.htm?sort.property=overallRating" className="link-btn">
            <img src="./assets/img/link-icon.svg" alt="" />
            https://www.merlot.org/
        </a>
    </div>
    </Col>
</Row>

         </Container>
    </section>
   
  </div>
  );
}
export default FreeOpenAccessResources;